import React, { Component } from "react";
import { getReferansGecerlilikKurallari } from "../../../services/common.service";


export default class ReferenceRules extends Component {

  state = {
    referansGecerlilik: "",
  };

  getReferansGecerlilik() {

    getReferansGecerlilikKurallari().then(
      response => {
        this.setState({ referansGecerlilik: response.data });
      },
      error => {}
    );
   }
  componentDidMount() {
     this.getReferansGecerlilik();
  }

 

  render() {

    return (
      <div className="container-fluid">
        {/* yesil Alan*/}
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            {/* KUTU 1 */}
            <div className="row no-gutters t-kutu t-yesilCizgi">
              <div
                className="col bosluk backtop"
                style={{
                  backgroundImage: 'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                }}
              >
                {/* içerikler */}
                {/* Başlık */}
                <div className="row no-gutters pb-4">
                  <div clss="col-auto">
                    <i className="t-icon-newspaper1 icon" />
                  </div>
                  <div className="col d-flex flex-column justify-content-center">
                    <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                      Referanslarım
                    </div>
                    <span className="altBaslik">Referans Geçerlilik Kuralları</span>
                  </div>
                </div>
                <div className="row no-gutters">
                  <div className="col-12 t-icYaziFontStandart">
                  <div dangerouslySetInnerHTML={{ __html: this.state.referansGecerlilik }} />
                    {/* <ol>
                      <li>
                        Yönlendirilen aday müşteri şubeyle irtibat kurduğunda mutlaka
                        kendisini yönlendiren kişinin adını belirtmelidir.
                      </li>
                      <li>
                        Referansın geçerli olabilmesi için; müşterinin daha önce kartı
                        ve görüşmesi varsa, en son görüşme 90 gün önce yapılmış
                        olmalıdır.{" "}
                      </li>
                      <li>
                        Müşterinin ilk referans beyanı; reklam, gazete, tanıtım
                        çalışması, web sitesi, internet/sosyal medya gibi isimler olup
                        da sonradan referans olarak düzeltmek isterse, talebi kabul
                        edilmez.{" "}
                      </li>
                      <li>
                        Müşterinin söylediği, ilk referans ismi esas alınır, daha
                        sonra yapacağı isim değişiklikleri kabul edilmez.
                      </li>
                      <li>
                        Gönüllünün yönlendirdiği referans üzerinden 1 yıl (12 ay)
                        boyunca ödül kazanılabilir. 1 yılı doldurulan referanslar ödül
                        alamaz. 1 yıl boyunca aynı müşteriye ikinci bir referans kabul
                        edilmez. İlk yönlendiren kişinin hakkı korunur.{" "}
                      </li>
                      <li>
                        Referans kurallarına uygun kayıt gerçekleştikten sonra ödül
                        kazanımı için zaman aşımı 15 aydır. Üzerinden 15 ay geçmiş
                        kayıtlar için ödül verilmemektedir. Zamanında ödeme yapılmamış
                        olması, 2.kayıtlarda geç not düşülmesi, referans teyidi
                        yapılamaması vb. sebepler zaman aşımı olarak değerlendirilir.
                        Ön kayıt açılan müşteri kesin kayıta döndüğü tarih itibariyle
                        15 aylık zaman aşımı başlar.{" "}
                      </li>
                      <li>
                        Kayıtlı müşteri kendisi için oluşturulan 2. ve sonraki
                        üyeliklerinde hediye ödüllerini alabilir. Bu kural; yeni
                        açılan sıfır kayıtlar ve teslimattan mahsup yapılan yeni
                        kayıtlar için geçerlidir.
                        <ol>
                          <li>
                            Teslimatın mahsubu hariç diğer mahsup üyeliklere (Geçiş,
                            mahsup, iade mahsup, kısmı iade mahsup ve bedel yükseltme
                            işlemlerinde) ödül verilmemektedir.{" "}
                          </li>
                          <li>
                            2. kayıtlarda kartın CRM’de ön-notlar sayfasına
                            “Müşterinin 2. Kaydıdır” notu düşülmeli Referans olan
                            Gönüllünün Temsilci Bağlantısı (Referans olan kişi)
                            kendisine yapılmalıdır.
                          </li>
                          <li>
                            Hisse dönüşüm kampanyalarından faydalandırılarak açılan
                            ikinci üyeliklere ödül verilmez{" "}
                          </li>
                          <li>
                            Ayrılma mahsup, geçiş, yükseltme gibi üyelikler ödül
                            alamaz.
                          </li>
                          <li>
                            CRM ön sayfada 2. üyelik notu olmayan üyelikler referans
                            değerlendirmesine alınmaz.{" "}
                          </li>
                        </ol>
                      </li>
                      <li>
                        Gönüllünün yönlendirdiği müşteri aynı gün birden fazla kayıt
                        açtırırsa hepsinin hediyesi yönlendiren gönüllüye yazılır,
                        devam eden gün farklı kayıt açılırsa 2. üyelik sayılır, kayıt
                        olan müşteriye hediye verilir.{" "}
                      </li>
                      <li>
                        Kaydın bir sonraki aya devir olması (ödemesi eksik, çekilişe
                        girmemiş, referans teyidi yapılamamış vb.) durumunda, devir
                        olan kısım, ödül hak edişine giren kısımdan ayrı
                        hesaplanacaktır.{" "}
                      </li>
                      <li>
                        Aday müşterilerde;
                        <ol>
                          <li>
                            Hem kartları hem de kayıtları aynı gün içerisinde
                            oluşturulan müşteriler birbirlerine referans olamazlar.
                          </li>
                          <li>
                            Aynı gün içerisinde kayıt oluşturulan kişilerden referans
                            olan kişinin üyeliği (aday müşteriyken TG yapılmadı ise)
                            referans olunan kişinin üyeliğinden sonra oluşturulduysa,
                            referans ödül değerlendirmesine girmez.
                          </li>
                          <li>
                            Aday Müşterinin verdiği referans kayda dönüşmeden,
                            yönlendiren kişi kayıtlı müşteri olduğu zaman ödül almaya
                            hak kazanır.
                          </li>
                          <li>
                            Gönüllü veya farklı bir statü tanımlaması yapılmamış Aday
                            Müşteriler ödül kazanamazlar. Referans notu olsa dahi
                            değerlendirmeye alınmaz. 1 yıl dolmadan farklı bir Gönüllü
                            tarafından yönlendirilmesi halinde yeni yönlendiren
                            Gönüllüye ödül verilir.{" "}
                          </li>
                        </ol>
                      </li>
                      <li>
                        Geçiş, üyelik bedeli arttırma ve mahsup işlemlerinde, referans
                        olan kişi yeni bir ödül kazanamaz.
                      </li>
                      <li>
                        Üyeliğin devredilmesi durumunda;
                        <ol>
                          <li>
                            Ödül kazanılan üyelik, ödül kesinleşmeden devir yapılması
                            durumunda, yönlendiren kişiye ödül verilir.
                          </li>
                          <li>
                            Ödül alacak olan Gönüllü üyeliğini devrederse, ödül devir
                            ettiği kişiye değil, ilk yönlendiren (devir eden) kişiye
                            verilir. Devir eden kişinin varsayılan statüsü Tanıtım
                            Gönüllüsü olarak devam eder.{" "}
                          </li>
                        </ol>
                      </li>
                      <li>
                        Referans kontrolleri yapılırken CRM Temsilci Bağlantısından
                        kontrol edileceği için CRM bağlantısının yapılmış olması
                        önemlidir. Temsilci Bağlantısı yapılmamış kartlar ödül
                        listesine alınmayacaktır.{" "}
                      </li>
                      <li>
                        Referans Kontrol İşlemleri;
                        <ol>
                          <li>
                            İşlemler; ödüle konu olan kayıtların, kayıt tarihini takip
                            eden ayın 25’inde kesinleşmesi ile başlamaktadır. Diğer
                            şartları taşıyan kayıtların kontrol işlemleri
                            tamamlandıktan sonra;
                          </li>
                          <li>
                            Peşinatlı ve vade ortası sistemde, kaydın “Kesin Kayıt”
                            türüne dönmüş olması gerekmektedir.
                          </li>
                          <li>
                            Çekilişli sistemde, çekilişe girmiş olması gerekmektedir.
                          </li>
                          <li>
                            Çağrı Merkezi tarafından yapılan referans teyit
                            aramalarında, kayıt olan üyenin, referans olan kişiyi
                            onaylaması gerekmektedir
                          </li>
                          <li>
                            Yukarıdaki şartları taşıyan üyeliklerin Hediye Çekleri,
                            kayıt tarihini takip eden 2. ayın 15’i itibariyle basımı
                            gerçekleştirilmektedir.
                          </li>
                          <li>
                            Ödeme, çekiliş ve referans teyidi şartlarını taşımayan
                            üyelikler bir sonraki ay tekrar kontrol edilmek üzere
                            devir listesine alınarak Müşteri Sadakat Yönetimi Birimi
                            tarafından takip edilir.{" "}
                          </li>
                        </ol>
                      </li>
                    </ol> */}
                  </div>
                </div>
                {/* içerikler BİTTİ */}
              </div>
              <div className="col-auto renk" />
            </div>
            {/* KUTU 1 BİTTİ */}
          </div>
        </div>
        {/* Duyurlar Baslık*/}
        {/* duyrular Bitti*/}
        <div className="row" style={{ height: 30 }} />
      </div>

    );
  }
}
